import React from 'react';
import AsyncSelect from 'react-select/async';
import PropTypes from 'prop-types';

import { searchLeaseSpaces } from 'components/lease_spaces/api';

export default class AssociatedLeaseSpaceSelector extends React.Component {
  static propTypes = {
    projectIds: PropTypes.array.isRequired,
    onModelAdded: PropTypes.func.isRequired
  };

  loadLeaseSpaceOptions = (inputValue, callback) => {
    searchLeaseSpaces(inputValue, this.props.projectIds, (leaseSpaces) => {
      const options = leaseSpaces.map((leaseSpace) => {
        return {
          value: leaseSpace.id,
          type: 'LeaseSpace',
          name: leaseSpace.name,
          projectName: leaseSpace.projectName,
          projectId: leaseSpace.projectId,
          displayName: `${leaseSpace.projectName} - ${leaseSpace.name}`,
        };
      });

      callback(options.filter(Boolean));
    });
  }

  onSelected = (selection) => {
    this.props.onModelAdded({
      associatedModelId: selection.value,
      associatedModelType: selection.type,
      name: selection.displayName,
      relatedAssociatedModelId: selection.projectId
    });
  }

  render() {
    const formatOptionLabel = ({ name, projectName }) => (
      <div>
        <strong>{name}</strong>
        <div>Project: {projectName}</div>
      </div>
    );

    return (
      <AsyncSelect
        autoFocus
        className="mb-4"
        defaultOptions
        formatOptionLabel={formatOptionLabel}
        loadOptions={this.loadLeaseSpaceOptions}
        placeholder="Search Spaces ..."
        value=""
        onChange={this.onSelected}
      />
    );
  }
}
